import React, { Fragment } from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { themeGet } from 'styled-system';
import { Card } from 'roo-ui/components';
import isNil from 'lodash/isNil';
import SearchResultHighlighter from 'pages/ListSearch/SearchResultHighlighter';
import SearchResultDetail from './SearchResultDetail';
import { useSelector } from 'react-redux';
import { getQueryFeaturedPropertyId, getQueryUtmSource, getQueryUtmCampaign } from 'store/search/searchSelectors/querySelectors';
import ExpandedClickableArea from 'components/ExpandedClickableArea';

const StyledCard = styled(Card)`
  padding: 0;
  position: relative;
  min-height: ${themeGet('imageSizes.searchThumbnailNotPhone.height')};
  box-shadow: ${themeGet('shadows.heavy')};
  transition: all 0.1s linear;
  &:hover {
    box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.1);
  }
`;

const isHighlighted = (featuredId, propertyId) => {
  if ([featuredId, propertyId].some(isNil)) return false;
  return Number(featuredId) === Number(propertyId);
};

const SearchResult = React.memo(({ result, index }) => {
  const featuredPropertyId = useSelector(getQueryFeaturedPropertyId);
  const utmCampaign = useSelector(getQueryUtmCampaign);
  const utmSource = useSelector(getQueryUtmSource);

  const highlighted = isHighlighted(featuredPropertyId, result.property.id);
  const Highlight = highlighted ? SearchResultHighlighter : Fragment;
  const referrerProp = highlighted ? { referrer: utmCampaign || utmSource } : {};

  return (
    <StyledCard data-testid="search-result" mb={[3, 5]}>
      <Highlight {...referrerProp}>
        <ExpandedClickableArea>
          <SearchResultDetail result={result} cardIndex={index} />
        </ExpandedClickableArea>
      </Highlight>
    </StyledCard>
  );
});

SearchResult.propTypes = {
  index: PropTypes.number.isRequired,
  result: PropTypes.shape({
    property: PropTypes.object.isRequired,
    offer: PropTypes.object.isRequired,
  }).isRequired,
};

export default SearchResult;
